var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0018 2C33.5443 2 37.3155 2 39.6587 4.48959C42.0018 6.97918 42.0018 10.9861 42.0018 19C42.0018 27.0139 42.0018 31.0208 39.6587 33.5104C37.3155 36 33.5443 36 26.0018 36L18.0018 36C10.4594 36 6.68812 36 4.34498 33.5104C2.00183 31.0208 2.00183 27.0139 2.00183 19C2.00183 10.9861 2.00183 6.97918 4.34498 4.48959C6.68812 2 10.4594 2 18.0018 2L26.0018 2Z",
    stroke: "#47525D",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00171 25.9998C11.219 21.7251 18.7095 21.4917 22.0017 25.9998M18.4998 15.5C18.4998 17.433 16.9328 19 14.9998 19C13.0668 19 11.4998 17.433 11.4998 15.5C11.4998 13.567 13.0668 12 14.9998 12C16.9328 12 18.4998 13.567 18.4998 15.5Z",
    stroke: "#47525D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0018 14L36.0018 14",
    stroke: "#47525D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0018 22H32.0018",
    stroke: "#47525D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconId);
export default __webpack_public_path__ + "static/media/icon-id.b0040ac9deefa5dc9de4e910d380a388.svg";
export { ForwardRef as ReactComponent };